import React from "react";
import "./Footer.css";

export const Footer = data => {
  return (
    <>
      <div className="row" className="footer">
        <footer>
          <div className="container-footer">
              <div className="row-footer">
                  
                  <div className="footer-col">
                      <h4>Empresa</h4>
                      <ul>
                          <li><a href="#/sobre-nos"> Quem somos </a></li>
                          <li><a href="#/contato"> Fale Conosco </a></li>
                      </ul>
                  </div>
                 
                  {/* <div className="footer-col">
                      <h4>Avaliações de Clientes</h4>
                      <ul>
                          <li>
                            <a href="#">Brenda Queiroz</a>
                            <span style={{ display: "block", color: "#fff", fontSize: "0.75rem", lineHeight: "1rem", marginTop: "5px"}}>
                                Alugamos nosso apartamento através da Vânia e do Cléber e 
                                podemos dizer que sem eles isso não seria possível, 
                                nos auxiliaram e prestaram todo atendimento da melhor maneira possível, 
                                com profissionalismo e humanidade sem tamanho, somos mto gratos por 
                                tudo que fizeram para que esse processo fosse o menos burocrático e 
                                cansativo.  Estamos muito felizes com a nossa locação, 
                                e a Vânia sempre nos presta quaisquer atenção todas as vezes que necessário. Indico e confio de olhos fechados. Muito obrigada.
                            </span>
                          </li>
                      </ul>
                  </div> */}
                
                  <div className="footer-col">
                      <h4>Afiliados</h4>
                      <ul>
                          <li><a href="https://sublime-bat-ad2fca1255.strapiapp.com/admin/auth/login"> Acesso para Corretores </a></li>
                          <li><a href="#/register">Venha ser parceiro TSA </a></li>
                      </ul>
                  </div>
                  
                  <div className="footer-col">
                      <h4>Medias Socias</h4>

                      <div className="medias-socias">
                          <a target="_blank" href="https://www.facebook.com/tudosobreap?locale=pt_BR"><i className="fa fa-facebook"></i></a>
                          <a target="_blank" href="https://www.instagram.com/tudosobreap/"><i className="fa fa-instagram"></i></a>
                          <a target="_blank" href="https://www.tiktok.com/@tsa.solues.imobil" style={{ float: "left"}}> 
                            <svg fill="#000000" style={{ width: "20px", fill: "#fff" }} 
                                viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier"> <title>tiktok</title>
                                <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path> 
                                </g>
                            </svg>
                          </a>
                      </div>
                  </div>
              </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
